import { createAction, createReducer, on } from '@ngrx/store';
import { LivePreviewInformation } from '@rappider/shared/interfaces';

import * as DeployManagementActions from './deploy-management.actions';
import * as AuthenticationActions from 'libs/authentication/src/lib/state/authentication.actions';
import * as ProjectSourceCodeActions from 'libs/project-source-code/src/lib/project-source-code-data-source/project-source-code.actions';
import { GitActionWorkflowRunDetailResponseDto } from '@rappider/rappider-sdk';
import { CurrentDeployStatus } from 'libs/project-design/src/lib/configs/current-deploy.enum';

export const deployManagementFeatureKey = 'deployManagement';

export interface DeployManagementState {
  deployInfo: any;
  applicationInfo: any;
  livePreviewInformation: LivePreviewInformation;
  loading: boolean;
  gitActionWorkflowRunDetails: GitActionWorkflowRunDetailResponseDto;
  applicationState: string;
  switchPosition: boolean | undefined;
  error: {
    error: any;
    key: string;
    timeStamp: number;
  };
}

export const initialState: DeployManagementState = {
  deployInfo: null,
  applicationInfo: null,
  livePreviewInformation: null,
  loading: false,
  applicationState: null,
  switchPosition: undefined,
  error: null,
  gitActionWorkflowRunDetails: null
};

const UpdateAuthenticationTokenWithProjectIdSuccessful = createAction(AuthenticationActions.ActionTypes.UpdateAuthenticationTokenWithProjectIdSuccessful);
const Logout = createAction(AuthenticationActions.ActionTypes.Logout);

export const reducer = createReducer(
  initialState,
  on(DeployManagementActions.DeployProject, (state) => ({
    ...state,
    loading: true
  })),
  on(DeployManagementActions.DeployProjectSuccessful, (state, action) => ({
    ...state,
    deployInfo: action.deployInfo,
    loading: false
  })),
  on(DeployManagementActions.DeployProjectFailure, (state, action) => ({
    ...state,
    loading: false,
    error: {
      error: action.error,
      key: action.key,
      timeStamp: action.timeStamp
    }
  })),
  on(DeployManagementActions.GetLivePreviewInformationSuccessful, (state, action) => ({
    ...state,
    livePreviewInformation: action.data
  })),
  on(DeployManagementActions.GetLivePreviewInformationFailure, (state, action) => ({
    ...state,
    error: {
      error: action.error,
      key: action.key,
      timeStamp: action.timeStamp
    }
  })),
  on(DeployManagementActions.SetLivePreviewInformation, (state, action) => ({
    ...state,
    livePreviewInformation: action.data
  })),
  on(DeployManagementActions.GetGitActionWorkflowRunDetailsSuccessful, (state, action) => ({
    ...state,
    gitActionWorkflowRunDetails: action.runDetails
  })),
  on(ProjectSourceCodeActions.DeploySuccessful, (state, action) => ({
    ...state,
    deployInfo: [
      action.payload.deployInfo,
      ...state.deployInfo
    ]
  })),
  on(ProjectSourceCodeActions.MonitorApplicationSuccessful, (state, action) => {
    let applicationState;
    let frontendState = action.payload.monitorApplicationInfo[0]?.State;
    let backendState = action.payload.monitorApplicationInfo[1]?.State;
    if (frontendState) {
      if (frontendState === CurrentDeployStatus.Running && backendState === CurrentDeployStatus.Running) {
        applicationState = CurrentDeployStatus.Running;
      } else {
        applicationState = CurrentDeployStatus.Exited;
      }
    } else {
      applicationState = undefined;
    }
    return {
      ...state,
      applicationInfo: action.payload.monitorApplicationInfo,
      applicationState,
      switchPosition: applicationState === CurrentDeployStatus.Running ? true : applicationState === undefined ? undefined : false
    }
  }),
  on(ProjectSourceCodeActions.StartApplication, (state) => ({
    ...state,
    applicationState: CurrentDeployStatus.Running,
    switchPosition: true
  })),
  on(ProjectSourceCodeActions.StopApplication, (state) => ({
    ...state,
    applicationState: CurrentDeployStatus.Exited,
    switchPosition: false
  })),
  on(UpdateAuthenticationTokenWithProjectIdSuccessful, () => (initialState)),
  on(Logout, () => (initialState))
);
